import { useEffect, useRef, useState } from 'react';
import { useFetchWrapper } from '../_helpers/fetchWrapper.js';
import config from '../config.js';

const EMPTY = { decades: [], genres: [], moods: [], tags: [] };

const list = (values) => (Array.isArray(values) ? values.filter((v) => v && v.value !== undefined) : []);

/**
 * The values the crate's filters offer (`GET /public/bands/{id}/songs/facets`,
 * ENG-706): only decades, genres, moods and tags some public song of the band
 * has, with counts. A failed read offers no filters rather than wrong ones.
 */
export const useCrateFacets = (bandId) => {
  const fetchWrapperRef = useRef(useFetchWrapper());
  const [facets, setFacets] = useState(EMPTY);

  useEffect(() => {
    let cancelled = false;
    if (!bandId) return undefined;
    fetchWrapperRef.current
      .get(`${config.apiBaseUrl}/public/bands/${bandId}/songs/facets`)
      .then((answer) => {
        if (cancelled) return;
        setFacets({
          decades: list(answer?.decades),
          genres: list(answer?.genres),
          moods: list(answer?.moods),
          tags: list(answer?.tags),
        });
      })
      .catch(() => {
        if (!cancelled) setFacets(EMPTY);
      });
    return () => { cancelled = true; };
  }, [bandId]);

  return facets;
};
